import { TopBar } from '@/common/components/TopBar/TopBar';

export type TFlowLayoutBarProps = {
  onBack?: () => void;
  onDismiss: () => void;
};

export function FlowLayoutBar({ onBack, onDismiss }: TFlowLayoutBarProps) {
  return <TopBar onBack={onBack} onClose={onDismiss} />;
}
